// id strings for messages/paywall.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const paywall: Dict = {
  // What each plan includes (the "What you get with <plan>" list).
  "paywall.hl.unlimitedCovers": "Cover tanpa batas",
  "paywall.hl.voices": "93.000+ suara",
  "paywall.hl.downloads": "Download",
  "paywall.hl.duetsTts": "Duet dan teks ke suara",
  "paywall.hl.trainVoices": "Latih suaramu",
  "paywall.hl.hdVideos": "Video 1080p",
  "paywall.hl.videoCoins": "50 koin video per bulan",
  "paywall.hl.marbleLyric": "Video Marble Run dan lirik",
  "paywall.hl.priority": "Pemrosesan prioritas",
  "paywall.hl.unlimitedCoins": "Koin video tanpa batas",
  "paywall.hl.apiCredits": "Kredit API $25 per bulan",
  "paywall.hl.everythingCreator": "Semua yang ada di Creator",
  "paywall.hl.thisCover": "Cover ini, sekarang juga",

  // Why the paywall opened: headline and line under it.
  "paywall.reason.unlock.title": "Buka covermu",
  "paywall.reason.unlock.body":
    "Suara dan audiomu sudah siap. Berlangganan dan covermu langsung diproses, jadi dalam sekitar satu menit. Setelah itu, bikin sebanyak yang kamu mau.",
  "paywall.reason.create.title": "Covermu siap dibuat",
  "paywall.reason.create.body":
    "Audio dan suaramu sudah diatur. Pilih paket untuk membuatnya, lalu bikin cover sebanyak yang kamu mau.",
  "paywall.reason.browse.title": "Bikin cover dengan suara apa pun",
  "paywall.reason.browse.body":
    "Cover tanpa batas, download, dan semua 93.000+ suara. Bisa dibatalkan kapan saja.",
  "paywall.reason.credits.title": "Kreditmu sudah habis",
  "paywall.reason.credits.body":
    "Cover berikutnya sudah menunggu. Basic tanpa batas, jadi kamu tidak perlu menghitung kredit lagi.",
  "paywall.reason.words.title": "Bikin suaranya mengucapkan kata-katamu",
  "paywall.reason.words.body":
    "Ketik kata-kata atau deskripsikan lagu, lalu suaranya akan menyanyikan atau mengucapkannya. Sudah termasuk mulai dari Basic.",
  "paywall.reason.video.title": "Jadikan video",
  "paywall.reason.video.body":
    "Video Marble Run dan lirik, siap untuk TikTok dan Reels. Creator sudah termasuk 50 koin video setiap bulan.",
  "paywall.reason.resume.title": "Lanjutkan dari terakhir kali",
  "paywall.reason.resume.body":
    "Paketmu sudah tersimpan. Selesaikan checkout, lalu bikin cover sebanyak yang kamu mau.",
  "paywall.reason.train.title": "Bikin suara yang tidak dimiliki orang lain",
  "paywall.reason.train.body":
    "Latih suaramu sendiri dari beberapa sampel dan pakai di cover mana pun. Tanpa batas di Creator.",

  // The main button.
  "paywall.cta.unlockFor": "Buka coverku seharga {price}",
  "paywall.cta.keepGoingFor": "Lanjutkan seharga {price}",
  "paywall.cta.backToCreatorFor": "Kembali ke Creator seharga {price}",
  "paywall.cta.backFor": "Kembali seharga {price}",
  "paywall.cta.startFor": "Mulai dengan {price}",
  "paywall.cta.startPlanFor": "Mulai {plan} seharga {price}",

  // Renewal terms next to the pay button (required before payment).
  "paywall.renew.welcome":
    "{price} per bulan selama kamu berlangganan. Diperpanjang setiap bulan sampai kamu membatalkan.",
  "paywall.renew.then":
    "Lalu {price} per bulan. Diperpanjang setiap bulan sampai kamu membatalkan.",
  "paywall.renew.yearly":
    "{price} ditagih hari ini untuk 12 bulan. Diperpanjang setiap tahun sampai kamu membatalkan.",

  "paywall.toast.updated": "Langgananmu sudah diperbarui!",
  "paywall.toast.error": "Ada yang salah, coba lagi, ya.",

  // Welcome back (their paid plan ended).
  "paywall.welcomeBack": "SELAMAT DATANG KEMBALI",
  "paywall.priceMonth": "{price} per bulan",
  "paywall.welcome.offerCreator": "Creator seharga {price} per bulan",
  "paywall.welcome.card":
    "Paketmu berhenti karena ada pembayaran yang gagal, bukan karena kamu pergi. Lanjutkan dari terakhir kali dengan {offer}.",
  "paywall.welcome.price":
    "Katamu harganya terlalu mahal, jadi ini lebih murah: {offer}, bukan {was}, selama kamu berlangganan.",
  "paywall.welcome.broken":
    "Katamu ada yang tidak berfungsi. Dalam seminggu terakhir, {n} dari 100 cover berhasil dengan baik. Kembali dengan {offer}.",
  "paywall.welcome.secretCreator":
    "Creator seharga {price} per bulan dengan paket yang tidak kami iklankan. Harga ini tetap milikmu selama kamu berlangganan.",
  "paywall.welcome.secret":
    "Semua yang kamu punya, seharga {price} per bulan dengan paket yang tidak kami iklankan. Harga ini tetap milikmu selama kamu berlangganan.",
  "paywall.welcome.coversHere": "{n} covermu masih ada di sini",
  "paywall.welcome.coverHere": "Covermu masih ada di sini",
  "paywall.welcome.makeAgain": "Bikin cover lagi",
  "paywall.ended.today": "Paketmu berakhir hari ini",
  "paywall.ended.yesterday": "Paketmu berakhir kemarin",
  "paywall.ended.days": "Paketmu berakhir {n} hari lalu",
  "paywall.ended.months": "Paketmu berakhir {n} bulan lalu",
  "paywall.more": "lagi",

  // Plan cards and the hero.
  "paywall.recommended": "DIREKOMENDASIKAN",
  "paywall.perMonth": "per bulan",
  "paywall.perMonthStay": "per bulan, selama kamu berlangganan",
  "paywall.firstMonth": "bulan pertama",
  "paywall.today": "hari ini",
  "paywall.heldFor": "Disimpan selama {time}",
  "paywall.coverReady": "COVERMU SIAP DIBUAT",
  "paywall.coverSetUp": "Audio dan suaramu sudah diatur",
  "paywall.coversToday": "{n} cover dibuat di Jammable hari ini",
  "paywall.coversTodayShort": "{n} cover dibuat hari ini",
  "paywall.pickPlanUnlock": "Pilih paket untuk membukanya",
  "paywall.pickPlan": "Pilih paket",
  "paywall.whatYouGet": "YANG KAMU DAPAT DENGAN {plan}",
  "paywall.secure": "Checkout aman dengan Stripe · batalkan kapan saja",
  "paywall.topPlan": "Kamu sudah pakai paket tertinggi kami",
  "paywall.managePlan": "Kelola paketmu",

  // Checkout step.
  "paywall.changePlan": "Ganti paket",
  "paywall.planYearly": "{plan}, tahunan",
  "paywall.planMonthly": "Paket {plan}",
  "paywall.billedYearly": "Ditagih tahunan",
  "paywall.pay": "Bayar",
  "paywall.payUnlock": "Bayar dan buka",
  "paywall.checkoutLoading": "Menyiapkan checkout-mu",

  // Leaving without the cover.
  "paywall.leave.title": "Pergi tanpa covermu?",
  "paywall.leave.oneStep": "Tinggal satu langkah lagi.",
  "paywall.leave.audioIn": "Audiomu sudah masuk",
  "paywall.leave.voiceReady": "{names} siap menyanyikannya",
  "paywall.leave.voicesReady": "{names} siap menyanyikannya",
  "paywall.leave.voicePicked": "Suaramu sudah dipilih",
  "paywall.leave.makeStep": "Buat covernya: sekitar satu menit",
  "paywall.leave.gets": "DENGAN MEMBUKANYA, KAMU DAPAT",
  "paywall.leave.held":
    "Cover ini disimpan selama {time}. Setelah itu akan hilang dan kamu harus membuatnya lagi.",
  "paywall.unlockMyCover": "Buka coverku",
  "paywall.leaveAnyway": "Tetap pergi",

  // The yearly gift on the leave step.
  "paywall.gift.wrapping": "Lagi membungkus sesuatu untukmu…",
  "paywall.gift.beforeYouGo": "SEBELUM KAMU PERGI",
  "paywall.gift.saved": "Kami menyimpan hadiah untukmu",
  "paywall.gift.openToSee": "Buka untuk melihat isinya.",
  "paywall.gift.opening": "Membuka…",
  "paywall.gift.open": "Buka hadiahku",
  "paywall.gift.noThanks": "Tidak, terima kasih",
  "paywall.gift.yours": "HADIAHMU",
  "paywall.gift.headline": "{plan} seharga {price} per bulan",
  "paywall.gift.body":
    "Cover tanpa batas dengan semua suara, harga terkunci selama 12 bulan.",
  "paywall.gift.save": "HEMAT {pct}%",
  "paywall.perMo": "/bln",
  "paywall.gift.billedYearly": "{price} ditagih tahunan",
  "paywall.gift.lockIn": "Kunci harga {price} per bulan",
  "paywall.seeMonthly": "Lihat paket bulanan",

  // The locked cover's page.
  "paywall.locked.step.upload": "Mengupload audiomu",
  "paywall.locked.step.match": "Mencocokkan suara",
  "paywall.locked.step.mix": "Menyiapkan mix",
  "paywall.locked.yourAudio": "audiomu",
  "paywall.locked.yourAiSong": "lagu AI-mu",
  "paywall.locked.yourWords": "kata-katamu",
  "paywall.locked.yourVoice": "Suaramu",
  "paywall.locked.startFailed": "Cover gagal dimulai. Coba lagi.",
  "paywall.locked.makeNow": "Buat sekarang",
  "paywall.unlock": "Buka",
  "paywall.locked.pctDone": "{pct}% selesai",
  "paywall.locked.gettingReady": "Menyiapkan {names} untuk {song}",
  "paywall.locked.done": "selesai",
  "paywall.locked.now": "sekarang",
  "paywall.locked.expired": "Cover ini sudah kedaluwarsa",
  "paywall.locked.expiredBody":
    "Cover yang terkunci disimpan selama 48 jam. Buat lagi dalam satu menit.",
  "paywall.locked.makeAgain": "Buat lagi",
  "paywall.locked.readyToMake": "Siap dibuat",
  "paywall.locked.readyOne": "Suara AI {names} siap menyanyikan {song}",
  "paywall.locked.readyMany": "Suara AI {names} siap menyanyikan {song}",
  "paywall.locked.onPlan":
    "Kamu sudah punya paket, jadi bisa langsung dimulai. Prosesnya sekitar satu menit.",
  "paywall.locked.unlockBody":
    "Buka dan covermu langsung diproses. Prosesnya sekitar satu menit, lalu kamu bisa download dan membagikannya.",
  "paywall.locked.change": "Ganti suara atau audio",
  "paywall.locked.notMade": "Cover ini belum dibuat",
  "paywall.locked.makeYourOwn":
    "Bikin covermu sendiri dengan {names} dalam sekitar satu menit.",
  "paywall.locked.makeCover": "Buat cover",

  // The locked video preview. "\n" is a line break.
  "paywall.video.unlock": "Buka cover\ndan videomu",
  "paywall.video.howItLooks": "Begini tampilan videomu nanti",
  "paywall.video.drawing": "Menggambar videomu",
  "paywall.video.aria": "{cta}: cover dan videomu",

  // The return bar.
  "paywall.return.firstMonth": "{price} untuk bulan pertamamu",
  "paywall.return.waiting": "Cover {title}-mu sudah menunggu",
  "paywall.return.savedWaiting": "Cover yang kamu simpan sudah menunggu",
  "paywall.return.trialReady": "Uji coba gratis 7 harimu sudah siap",
  "paywall.return.trialDetail":
    "Tidak ada tagihan hari ini, lalu {price} per bulan. Batalkan kapan saja.",
  "paywall.return.startTrial": "Mulai uji coba gratisku",
  "paywall.return.funds": "Kata bankmu, saldo kartunya tidak cukup.",
  "paywall.return.declined": "Bankmu menolak pembayarannya.",
  "paywall.return.cardFailed": "Pembayaran dengan kartumu gagal",
  "paywall.return.cardDetail":
    "Pembayaran dengan kartumu gagal. Coba Apple Pay, Google Pay, atau kartu lain · {price}",
  "paywall.return.whyDetail":
    "{why} Coba Apple Pay, Google Pay, atau kartu lain · {price}",
  "paywall.return.tryAnother": "Coba cara lain",
  "paywall.return.confirm": "Bankmu minta konfirmasi singkat",
  "paywall.return.confirmDetail": "Satu langkah lagi dan selesai · {price}",
  "paywall.return.finish": "Selesaikan pembayaran",
  "paywall.return.planHere": "Paket {plan}-mu masih ada di sini",
  "paywall.return.heldMore": "Disimpan {time} lagi · {price}",
  "paywall.return.thenRegular": "{price}, lalu {regular}",
  "paywall.return.cancelAny": "{price}, batalkan kapan saja",
  "paywall.return.pickUp": "Lanjutkan dari terakhir kali",
  "paywall.return.cardStopped":
    "Paketmu berhenti karena ada pembayaran yang gagal",
  "paywall.return.comeBack": "Kembali ke Jammable",
  "paywall.return.pickUpFor": "Lanjutkan dari terakhir kali dengan {offer}.",
  "paywall.return.secretOffer":
    "Kembali dengan {offer}, dengan paket yang tidak kami iklankan.",
  "paywall.return.hide": "Sembunyikan",
};

export default paywall;
